import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      <h1>Privacy Policy</h1>
      <p>At Calender application , we respect your privacy and are committed to protecting the personal data you share with us. Our application accesses your Google Calendar to provide you with the ability to add, view, and manage events directly from within the app. By using our services, you consent to our access of your Google Calendar data, which includes event details such as titles, descriptions, dates, times, and attendees. This data is solely used to enhance your experience by enabling calendar management features and is not shared with third parties, except when required by law or to fulfill the service. You can manage or revoke access to your Google Calendar at any time through your Google account settings. We take the security of your data seriously and use industry-standard measures to protect it. For more information on how your data is handled, please read the full privacy policy.

</p>
    </div>
  );
};

export default PrivacyPolicy;
